<style lang="scss" scoped>
button {
    transition: all 0.2s;
    display: flex;
    justify-content: center;

    &.loading,
    &.success {
        //padding: 13px 25px;
    }
    &:disabled {
        pointer-events: none;
        opacity: 0.6;
    }
    .checkmark {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        margin-left: 15px;

        &::after {
            content: "";
            display: block;
            width: 10px;
            height: 18px;
            margin-top: -10px;
            border: solid #fff;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
        }
    }
}
</style>

<template>
    <button data-tc-btn-submit :disabled="loading || disabled" type="submit" @click="$emit('click')" :class="[{ loading: loading, success: success }]">
        {{ !loading && !success ? defaultLabel : loading ? loadingLabel : successLabel }}
        <el-loader v-if="!noEffects" :loading="loading" class="my-auto ml-16" />
        <div v-if="!noEffects" v-show="!loading && success" class="checkmark my-auto ml-16"></div>
    </button>
</template>

<script>
export default {
    name: "Forms.Elements.ElButton",

    props: {
        defaultLabel: { type: String },
        loadingLabel: { type: String },
        successLabel: { type: String },
        loading: { default: false },
        success: { default: false },
        disabled: { default: false },
        noEffects: { type: Boolean, default: false },
        noArrow: { type: Boolean, default: false },
    },
    components: {
        ElLoader: () => import(/* webpackChunkName: "elements" */ "./ElLoader")
    }
};
</script>
